import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import CommonTop from '../pools/CommonTop';
import PoolsOverview from '../pools/card/PoolsOverview';
import { totalStakeUsdt } from '@/api/staking/read';

export default function ConnectWallet() {
  const [totalUsdt, setTotalUsdt] = useState('');

  useEffect(() => {
    (async () => {
      const re = await totalStakeUsdt();
      setTotalUsdt(re.data);
    })();
    return () => {};
  }, []);

  // useEffect(() => {
  //   if (address) {
  //     return;
  //   }
  //   (async () => {
  //     if (web3authCall?.connected()) {
  //       const addr = await web3authCall.getAddress();
  //       setAddress(addr);
  //     }
  //   })();
  //   return () => {};
  // }, [web3authCall, address]);

  return (
    <>
      <CommonTop title="Pools" subtitle="Pools Of Real-World Assets">
        <Box
          sx={{
            // maxWidth: '1680px',
            maxWidth: '460px',
            padding: '16px 24px',
            display: 'flex',
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
            gap: {
              xs: '10px',
              sm: '20px',
            },
          }}
        >
          <PoolsOverview title="Total Staked" content={`${totalUsdt} USD`} />
          {/* <PoolsOverview title="Total Staked" content={`${totalUsdt} USD`} />
          <PoolsOverview title="Total Achievment Rate" content="83.42 aaaaa%" /> */}
          {/*<PoolsOverview title="Total Number Of Wallets" content="60 aaaaa" /> */}
        </Box>
      </CommonTop>

      {/* {isInfo && <ConnectInfo open={isInfo} onClose={handleClose} />} */}
    </>
  );
}
